import { environment } from '../../../../../../../../environments/environment';
import { Coordinates } from '../types/go-map-types';

/** Geographic center of the contiguous US */
export const DEFAULT_GEO_CENTER: Readonly<Coordinates> = {
    latitude: 39.8283,
    longitude: -98.5795,
} as const;

/**
 * Base Google Maps options used for CevoGo.
 * You will still need to pass in a value for the 'center' key.
 */
export const DEFAULT_MAP_OPTIONS: Readonly<google.maps.MapOptions> = {
    zoom: 14,
    mapId: environment.googleMapsMapId,
    streetViewControl: false,
    rotateControl: false,
    mapTypeControlOptions: {
        mapTypeIds: ['roadmap', 'hybrid'],
    },
} as const;
